import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M15 19H3V17H15V19ZM21 15H3V13H21V15ZM15 11H3V9H15V11ZM21 7H3V5H21V7Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "TextAlignLeft"
);
